var _path, _path2, _path3, _path4, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoCcdmd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_20",
    "data-name": "Groupe 20",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.93,
    height: 49.342,
    viewBox: "0 0 46.93 49.342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10",
    "data-name": "Trac\\xE9 10",
    d: "M53.927,746.891l-4.482-6.169-4.479-6.167-4.485-6.167L36,722.223l4.481-6.17,4.479-6.167,4.481-6.17,4.481-6.166,7.251,2.353,7.251,2.355,7.251,2.355,7.253,2.351V729.84l0,7.624-7.252,2.356L68.43,742.18l-7.254,2.355Z",
    transform: "translate(-36 -697.549)",
    fill: "#56575a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11",
    "data-name": "Trac\\xE9 11",
    d: "M49.3,740.226l-2-6.165-2-6.16-2.008-6.165-2-6.163,5.244-3.808,5.242-3.811,5.243-3.809,5.242-3.807,5.244,3.806,5.244,3.811,5.243,3.807,5.246,3.807-2,6.166-2,6.163-2,6.164-2,6.163H68.738l-6.479,0-6.482,0Z",
    transform: "translate(-36.318 -697.717)",
    fill: "#797b7e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12",
    "data-name": "Trac\\xE9 12",
    d: "M47.466,733.673V722.66l0-5.512v-5.507l5.24-1.7,5.239-1.7,5.239-1.7,5.237-1.7,3.24,4.455,3.238,4.457,3.239,4.457,3.24,4.453-3.24,4.459-3.239,4.456-3.237,4.457-3.237,4.455-5.24-1.7-5.238-1.7-5.24-1.7Z",
    transform: "translate(-36.689 -697.987)",
    fill: "#b5b7ba"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13",
    "data-name": "Trac\\xE9 13",
    d: "M47.477,727.9l1.447-4.455,1.446-4.45,1.446-4.455,1.446-4.451h4.683l4.682,0H71.99l1.449,4.451,1.446,4.454,1.447,4.453,1.45,4.451-3.791,2.754L70.2,733.4l-3.788,2.751L62.63,738.9l-3.79-2.754-3.788-2.75-3.789-2.753Z",
    transform: "translate(-36.69 -698.302)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_19",
    "data-name": "Groupe 19",
    transform: "translate(17.279 26.115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_14",
    "data-name": "Trac\\xE9 14",
    d: "M56.534,729.669a2.167,2.167,0,0,1,.012-4.335,2.178,2.178,0,0,1,1.257.333l-.4.648a1.494,1.494,0,0,0-.873-.245,1.241,1.241,0,0,0-1.206,1.4c0,.8.4,1.457,1.218,1.457a1.474,1.474,0,0,0,.948-.32l.365.621a2.1,2.1,0,0,1-1.325.441",
    transform: "translate(-54.385 -725.334)",
    fill: "#313133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_15",
    "data-name": "Trac\\xE9 15",
    d: "M60.833,729.669a2.167,2.167,0,0,1,.012-4.335,2.178,2.178,0,0,1,1.257.333l-.4.648a1.494,1.494,0,0,0-.873-.245,1.241,1.241,0,0,0-1.206,1.4c0,.8.4,1.457,1.218,1.457a1.474,1.474,0,0,0,.948-.32l.365.621a2.1,2.1,0,0,1-1.325.441",
    transform: "translate(-54.643 -725.334)",
    fill: "#313133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16",
    "data-name": "Trac\\xE9 16",
    d: "M64.593,726.125h-.383v2.763h.414a1.259,1.259,0,0,0,1.42-1.413c0-.936-.459-1.351-1.451-1.351m-.038,3.474H63.324v-4.184h1.262c1.646,0,2.393.83,2.393,2.036s-.759,2.149-2.424,2.149",
    transform: "translate(-54.922 -725.339)",
    fill: "#313133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_17",
    "data-name": "Trac\\xE9 17",
    d: "M69.871,729.6l-.71-2.167c-.082-.271-.17-.6-.17-.6h-.012s-.025.339-.056.616l-.27,2.155h-.8l.578-4.184h.861L70.135,728c.106.308.213.723.213.723h.012s.114-.414.22-.723l.867-2.582H72.3l.578,4.184h-.9l-.27-2.161c-.038-.3-.07-.61-.07-.61h-.012s-.082.314-.17.6l-.71,2.174Z",
    transform: "translate(-55.195 -725.339)",
    fill: "#313133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_18",
    "data-name": "Trac\\xE9 18",
    d: "M75.533,726.125h-.383v2.763h.414a1.259,1.259,0,0,0,1.42-1.413c0-.936-.459-1.351-1.451-1.351M75.5,729.6H74.264v-4.184h1.262c1.646,0,2.394.83,2.394,2.036S77.16,729.6,75.5,729.6",
    transform: "translate(-55.58 -725.339)",
    fill: "#313133"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCcdmd);
export default __webpack_public_path__ + "static/media/logo_ccdmd.a26cd7db7a784c1f8e7280f826b0c581.svg";
export { ForwardRef as ReactComponent };